module.exports = __webpack_public_path__ + "static/GS-67aa9b0196d73565c052b67613baf411.svg";